import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPaymentMethods = async () => {
  try {
    const response = await Axios.get('payment-methods');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};


const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('payment-methods/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadPaymentMethod = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/payment-methods');
        const responseData = await response.data;
        return {...responseData, paymentMethod: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePaymentMethodAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('payment-methods', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('paymentMethod_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('payment-methods/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('paymentMethod_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  return { create, update };
};



export default usePaymentMethodAPI;


